import swal from "sweetalert";

export const alert = (title, data, type) => {
  return swal(title, data, type);
};

export const warning = () => {
  return swal({
    title: "Emin misin?",
    icon: "warning",
    dangerMode: true,
    buttons: ["Vazgeç", "Evet"],
  });
};

//Delete Warning for category
export const warningForText = (text) => {
  return swal({
    title: "Emin misin?",
    text: text,
    icon: "warning",
    dangerMode: true,
    buttons: ["Vazgeç", "Evet"],
  });
};

